
import {useState} from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import Translate from '../components/Translate';
import Scanner from '../components/Scanner';
/*
   @payment
   @input 
   @result
     <span className ='btn btn-sm btn-danger rounded'>
                                    <i className ='fa fa-barcode ' style ={{fontSize:'150%'}}></i>
                               </span>
*/
const Online = ()=>{

    const [value,setValue] = useState('');
  
    return (
        <>
            <div className ='row my-2'>
                  <div className ='form-group mx-auto' style ={{maxWidth:'650px'}}>
                       <label><Translate k='trackingNumber' /><sup>*</sup></label>
                       <div className = 'input-group'>
                           <input 
                               type ='text' 
                               className ='form-control eparts-input' 
                               placeholder ='...'
                               readOnly = {true}
                               value = {value || ''}
                              
                           />
                           <div className ='input-group-append'>
                               <Scanner 
                                  url = {`${window.location.href}`} 
                                  callBack = {setValue}
                              />
                           </div>
                       </div>
                  </div>
            </div>
           
            
            <Tabs defaultActiveKey="home">
                <Tab eventKey="home" 
                    className ='rounded' 
                    style = {{fontSize:'85%'}}
                    title={ 
                        <>
                        <i className ='fa fa-list mr-2'></i>
                        <Translate k= {'home'} />
                        </>
                    } 
                 >


                    <div 
                    
                    style ={{
                        marginTop:'8vh',
                        minHeight:'150px',
                        backgroundImage:'url('+require('../images/pallet.jpg')+')',
                        backgroundPosition: 'center',
                        backgroundSize: '85%',
                        backgroundRepeat: 'no-repeat',
                    }}>
                    ...
                    </div>


                </Tab>
            </Tabs>
            
        
        </>
    );

};

export default Online;
